import React, { useState } from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Typography,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import { updatePurchaseStatus } from "app/services/apis/Purchase Order/updatePurchaseStatus";
import { useDispatch } from "react-redux";
import { getAllPurchase } from "app/redux/actions/purchaseAction";

export default function PurchaseRawInfoTable({ itemDetails, itemId }) {
  const navigate = useNavigate();
  const [order, setOrder] = useState("");
  const [orderBy, setOrderBy] = useState("id");
  const dispatch = useDispatch();
  const allpurchase = itemDetails;
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  // console.log(itemId);
  // console.log(itemDetails);
  // console.log(allpurchase);

  // console.log(allpurchase);
  // const sortedData = allpurchase?.sort((a, b) => {
  //   const aValue = a[orderBy];
  //   const bValue = b[orderBy];
  //   if (order === "desc") {
  //     return aValue < bValue ? -1 : 1;
  //   } else {
  //     return bValue < aValue ? -1 : 1;
  //   }
  // });

  const handleStatus = async (purchaseId, id, body) => {
    const res = await updatePurchaseStatus(purchaseId, id, body);
    // console.log(res);
    if (res?.status == 200) {
      dispatch(getAllPurchase());
      navigate("/dashboard/purchase");
    }
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow sx={{ bgcolor: "#202020", color: "white" }}>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "10%",
                verticalAlign: "middle",
                color: "white",
              }}
            >
              Kennys Fabric Code
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "10%",
                verticalAlign: "middle",
                color: "white",
              }}
            >
              Supplier Fabric Code
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "10%",
                verticalAlign: "middle",
                color: "white",
              }}
            >
              Rate Per Unit
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                maxWidth: "100px",
                verticalAlign: "middle",
                color: "white",
              }}
            >
              Quantity
            </TableCell>

            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "80px",
                verticalAlign: "middle",
                color: "white",
              }}
            >
              Amount
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "40px",
                verticalAlign: "middle",
                color: "white",
              }}
            >
              Image
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "40px",
                verticalAlign: "middle",
                color: "white",
              }}
            >
              Status
            </TableCell>
            {permissions?.purchase_edit == true && (
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "40px",
                  verticalAlign: "middle",
                  color: "white",
                }}
              >
                Action
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {allpurchase?.map((row, i) => (
            <TableRow key={i}>
              <TableCell
                sx={{
                  textAlign: "left",
                  pl: 2,
                }}
              >
                {row?.kc_fabric_code}
              </TableCell>
              <TableCell sx={{ textAlign: "left" }}>
                {row?.supplier_fabric_code}
              </TableCell>
              <TableCell sx={{ textAlign: "left" }}>
                {row?.rate_per_meter}
              </TableCell>
              <TableCell sx={{ textAlign: "left" }}>{row?.quantity}</TableCell>
              <TableCell sx={{ textAlign: "left" }}>
                {row?.total_amount}
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  p: 1,
                }}
              >
                <img
                  width={"100px"}
                  height={"100px"}
                  src={`${process.env.REACT_APP_URL}/${row?.image}`} // Replace 'image_url' with the actual field containing the image URL in your data
                />
              </TableCell>
              <TableCell sx={{ textAlign: "left" }}>
                {row?.po_item_status}
              </TableCell>
              {permissions?.purchase_edit == true && (
                <TableCell sx={{ textAlign: "left" }}>
                  {row?.po_item_status == "Complete" && "N/A"}
                  {row?.po_item_status == "Partial Cancelled" && "N/A"}
                  {row?.po_item_status == "Cancelled" && "N/A"}
                  {row?.po_item_status == "Not Received" && (
                    <Typography
                      color={"blue"}
                      sx={{ cursor: "pointer" }}
                      onClick={() => handleStatus(itemId, row?.id, "Cancelled")}
                    >
                      Cancel
                    </Typography>
                  )}
                  {row?.po_item_status == "Partial Received" && (
                    <Typography
                      color={"blue"}
                      sx={{ cursor: "pointer" }}
                      onClick={() =>
                        handleStatus(itemId, row?.id, "Partial Cancelled")
                      }
                    >
                      Partial Cancel
                    </Typography>
                  )}
                  {row?.po_item_status == "Completed" && "N/A"}
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
